function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import { fromEntries } from "@chakra-ui/utils";
export var createBreakpoints = function createBreakpoints(config) {
  var sorted = fromEntries(Object.entries(_extends({
    base: "0em"
  }, config)).sort(function (a, b) {
    return parseInt(a[1]) > parseInt(b[1]) ? 1 : -1;
  }));
  return Object.assign(Object.values(sorted), sorted);
};